import { Container, Grid, Heading, Paragraph } from '@ingeniorforeningen/figurine-core';

export const ErrorPage = () => {
  return (
    <Container style={{ padding: 20 }}>
      <Grid container my="xl">
        <Grid item>
          <>
            <Heading type="h1" text="Vi er ved at opdatere siden" mb="xl" />
            <Paragraph text="Vi er ved at opdatere og optimere systemerne, der driver siden, så platformen forbliver stabil og sikker." />
            <Paragraph text="Derfor er siden ikke tilgængelige lige nu." />
            <Paragraph text="Vi er snart oppe igen og håber på din forståelse." />

            <Heading type="h1" text="We are updating the page" my="xl" />
            <Paragraph text="We are currently updating and optimizing the systems that run the site to secure the platform remains stable and secure." />
            <Paragraph text="Therefore, the page is not available right now." />
            <Paragraph text="The page will be up again soon. We hope for your understanding." />
          </>
        </Grid>
      </Grid>
    </Container>
  );
};
